import LegalLayout from "@/components/feature/LegalLayout";
import { usePageMeta } from "@/hooks/usePageMeta";

function Section({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <section className="mb-8">
      <h2 className="font-heading text-2xl tracking-wide text-foreground-900 mb-3">
        {title}
      </h2>
      <div className="text-sm text-foreground-700 leading-relaxed space-y-3">
        {children}
      </div>
    </section>
  );
}

export default function PolitiqueConfidentialite() {
  usePageMeta(
    "Politique de confidentialité | Mobicar Pro",
    "Politique de confidentialité de Mobicar Pro : données collectées, finalités, durée de conservation et exercice de vos droits RGPD.",
    "https://www.mobicarpro.re/politique-de-confidentialite"
  );

  return (
    <LegalLayout title="Politique de confidentialité">
      <p className="text-sm text-foreground-600 mb-8">
        Dernière mise à jour : septembre 2026
      </p>

      <Section title="1. Responsable du traitement">
        <p>
          Le responsable du traitement des données est la société MOBICAR PRO,
          SASU au capital de 1 000 €, dont le siège social est situé 99 avenue
          Achille Peretti, 92200 Neuilly-sur-Seine, immatriculée au RCS de
          Nanterre sous le numéro 985 034 008.
        </p>
      </Section>

      <Section title="2. Données collectées">
        <p>
          Lorsque vous contactez le garage (par téléphone, par e-mail ou via
          WhatsApp) ou que vous sollicitez un devis, nous pouvons être amenés à
          collecter les données suivantes : nom et prénom, numéro de téléphone,
          adresse e-mail, ainsi que les informations relatives à votre véhicule
          (marque, modèle, immatriculation, nature de la panne ou de
          l&apos;intervention demandée).
        </p>
      </Section>

      <Section title="3. Finalités du traitement">
        <p>Les données collectées sont utilisées pour :</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>répondre à vos demandes de renseignements et de devis ;</li>
          <li>organiser les rendez-vous et réaliser les interventions ;</li>
          <li>établir les devis et les factures ;</li>
          <li>assurer le suivi de la relation client.</li>
        </ul>
      </Section>

      <Section title="4. Base légale du traitement">
        <p>
          Le traitement de vos données repose sur l&apos;exécution de mesures
          précontractuelles ou contractuelles (demande de devis, réalisation
          d&apos;une prestation), sur le respect d&apos;obligations légales
          (notamment comptables et fiscales) et, le cas échéant, sur votre
          consentement.
        </p>
      </Section>

      <Section title="5. Durée de conservation">
        <p>
          Les données sont conservées pendant la durée nécessaire aux finalités
          décrites ci-dessus, dans la limite des délais légaux de conservation
          en vigueur, notamment en matière comptable et fiscale.
        </p>
      </Section>

      <Section title="6. Destinataires des données">
        <p>
          Les données sont destinées exclusivement à MOBICAR PRO et ne sont ni
          vendues ni cédées à des tiers. Elles peuvent être communiquées aux
          seuls prestataires intervenant pour notre compte (hébergement,
          maintenance) dans la limite de leurs missions.
        </p>
      </Section>

      <Section title="7. Vos droits">
        <p>
          Conformément au Règlement général sur la protection des données
          (RGPD), vous disposez d&apos;un droit d&apos;accès, de rectification,
          d&apos;effacement, de limitation, d&apos;opposition et de portabilité
          de vos données. Pour exercer ces droits, vous pouvez nous contacter à
          l&apos;adresse suivante : contact@mobicar.pro.
        </p>
        <p>
          Vous disposez également du droit d&apos;introduire une réclamation
          auprès de la Commission nationale de l&apos;informatique et des
          libertés (CNIL).
        </p>
      </Section>

      <Section title="8. Cookies">
        <p>
          Le site peut utiliser des cookies strictement nécessaires à son
          fonctionnement ainsi que des cookies de mesure d&apos;audience. Vous
          pouvez configurer votre navigateur pour refuser ou supprimer les
          cookies à tout moment.
        </p>
      </Section>

      <Section title="9. Sécurité">
        <p>
          MOBICAR PRO met en œuvre des mesures techniques et organisationnelles
          appropriées afin de protéger vos données contre tout accès non
          autorisé, altération, divulgation ou destruction.
        </p>
      </Section>
    </LegalLayout>
  );
}